import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface VacationPauseState {
    isVacationPause: boolean;
    queryParam: string;
}

const initialState: VacationPauseState = {
    isVacationPause: false,
    queryParam: "vacationpause"
};

export const vacationPauseSlice = createSlice({
    name: 'vacationPause',
    initialState,
    reducers: {
        setIsVacationPause: (state, action: PayloadAction<boolean>) => {
            state.isVacationPause = action.payload;
        },
    },
});

export const { setIsVacationPause } = vacationPauseSlice.actions;
export default vacationPauseSlice.reducer;